import { Typography } from "@mui/material";
import { EPath } from "constants/path";
import { useMemo } from "react";
import { useNavigate } from "react-router";

import { PrescriptionCard } from "./PrescriptionCard";

export interface IPrescriptionPatientCardProps {
  name?: string;
  email?: string;
  phone?: string;
  patientId: string;
  onViewDetails?: () => void;
}

export const PrescriptionPatientCard = ({
  name,
  email,
  phone,
  patientId,
}: IPrescriptionPatientCardProps) => {
  const navigate = useNavigate();
  const persistedStyle = useMemo(
    () => ({
      className: "break-words",
      sx: { fontWeight: 600 },
    }),
    []
  );
  const patientInformation = useMemo(
    () => [
      {
        label: "Name",
        value: <Typography {...persistedStyle}>{name ?? "N/A"}</Typography>,
      },
      {
        label: "Email",
        value: <Typography {...persistedStyle}>{email ?? "N/A"}</Typography>,
      },
      {
        label: "Phone",
        value: <Typography {...persistedStyle}>{phone ?? "N/A"}</Typography>,
      },
    ],
    [email, name, persistedStyle, phone]
  );
  return (
    <PrescriptionCard
      title="Patient Information"
      items={patientInformation}
      onViewAction={() =>
        navigate(EPath.PATIENT_DASHBOARD.replace(":patientId", patientId))
      }
      actionButtonText="View Details"
    />
  );
};
